import { Check } from 'lucide-react';
import type { AnatomyHotspot as Hotspot } from '@/data/cardAnatomy';

type Props = {
  hotspot: Hotspot;
  active: boolean;
  done: boolean;
  onClick: () => void;
};

export function AnatomyHotspot({ hotspot, active, done, onClick }: Props) {
  const w = hotspot.w ?? 12;
  const h = hotspot.h ?? 8;
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={`${hotspot.label}${done ? ' (explored)' : ''}`}
      aria-pressed={active}
      className={`absolute -translate-x-1/2 -translate-y-1/2 rounded-md border-2 transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-background ${
        active
          ? 'border-primary bg-primary/30 shadow-[0_0_0_3px_hsl(var(--primary)/0.25)]'
          : done
            ? 'border-ink-emerald/70 bg-ink-emerald/15 hover:bg-ink-emerald/25'
            : 'border-primary/70 bg-primary/10 animate-pulse hover:bg-primary/25 hover:animate-none'
      }`}
      style={{
        left: `${hotspot.x}%`,
        top: `${hotspot.y}%`,
        width: `${w}%`,
        height: `${h}%`,
      }}
    >
      {done && (
        <span className="absolute -top-1.5 -right-1.5 flex h-4 w-4 items-center justify-center rounded-full bg-ink-emerald text-background">
          <Check className="h-2.5 w-2.5" strokeWidth={3} />
        </span>
      )}
      <span className="sr-only">{hotspot.label}</span>
    </button>
  );
}
